<template>
<div class="chapter">
<div class="inner_page">
<h1 class="sgc-toc-title"><i>Contents</i></h1>
<div class="sgc-toc-level-1">
<br/>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/01_Fm01">Dedication</a><br/>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/02_Fm02">Epigraph</a>
</div>
<div class="sgc-toc-level-1">
<br/>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/04_Part01">I   <span class="bigcaps">Drunk With Love</span></a>
<div class="sgc-toc-level-2">
<a href="#/Text/05_Chapter01">Drunk With Love</a>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/06_Chapter02" title="Link target outside of Sample">Nineteen Forty-One</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/07_Chapter03" title="Link target outside of Sample">The Expansion of the Universe</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/08_Chapter04" title="Link target outside of Sample">Adoration</span>
</div>
</div>
<div class="sgc-toc-level-1">
<br/>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/09_Part02" title="Link target outside of Sample">II   <span class="bigcaps">Bad Times in a Good Land</span></span>
<div class="sgc-toc-level-2">
<span href="#/Text/10_Chapter05" title="Link target outside of Sample">The Emancipator</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/11_Chapter06" title="Link target outside of Sample">Memphis</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/12_Chapter07" title="Link target outside of Sample">The Young Man</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/13_Chapter08" title="Link target outside of Sample">First Manhattans</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/14_Chapter09" title="Link target outside of Sample">The Cast Diet</span>
</div>
</div>
<div class="sgc-toc-level-1">
<br/>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/15_Part03" title="Link target outside of Sample">III   <span class="bigcaps">The Islands</span></span>
<div class="sgc-toc-level-2">
<span href="#/Text/16_Chapter10" title="Link target outside of Sample">The Blue-Eyed Buddhist</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/17_Chapter11" title="Link target outside of Sample">Belize</span>
</div>
</div>
<div class="sgc-toc-level-1">
<br/>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/18_Part04" title="Link target outside of Sample">IV   <span class="bigcaps">The Dishes Can Wait</span></span>
<div class="sgc-toc-level-2">
<span href="#/Text/19_Chapter12" title="Link target outside of Sample">Traceleen at Dawn</span>
</div>
<div class="sgc-toc-level-2">
<span href="#/Text/20_Chapter13" title="Link target outside of Sample">Anna, Part 1</span>
</div>
</div>
<div class="sgc-toc-level-1">
<br/>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/21_Other" title="Link target outside of Sample">Also by Ellen Gilchrist</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Section0001" title="Link target outside of Sample">Connect with Diversion Books</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?1a3b180c